import LlmCategorizerName from 'components/IdentifierName/LLMCategorizer/LlmCategorizerName';
import { ACTIVE_ICON, INACTIVE_ICON, TEST_ICON } from 'constants/annotatorIcons';

export * from 'constants/annotatorIcons';

const MATCHER_TYPE = {
  development: {
    name: 'Test',
    icon: TEST_ICON,
  },
  disabled: {
    name: 'Inactive',
    icon: INACTIVE_ICON,
  },
  active: {
    name: 'Active',
    icon: ACTIVE_ICON,
  },
};

export const mapInputChoices = (
  choices: (string | number)[],
  formType: string
): {
  name: React.Key;
  value: React.Key;
}[] => {
  const prunedChoices = choices.map((choice) => {
    if (formType !== 'status') return { name: choice, value: choice };
    const name =
      choice in MATCHER_TYPE ? MATCHER_TYPE[choice as keyof typeof MATCHER_TYPE].name : choice;
    return { name, value: choice };
  });
  return prunedChoices;
};

export const possibleTypes = {
  freeForm: 'freeForm',
  bool: 'bool',
  multiSelect: 'multiSelect',
  singleSelect: 'singleSelect',
  int: 'int',
};

export const matcherTypeLabelMap: Record<string, string> = {
  token: 'Token',
  adjacent_tokens: 'Adjacent tokens',
  describes: 'Describes',
  keyword: 'Keyword',
  metadata_communication: 'Metadata communication',
  metadata_length: 'Metadata length',
  metadata_recipient: 'Metadata recipient',
  metadata_sender: 'Metadata sender',
  money: 'Money',
  regex: 'Regex',
  raw_regex: 'Raw Regex',
  token_with_modifier: 'Token with modifier',
  url: 'Url',

  text: 'Main',
  secondary: 'Secondary',
  categories: 'Categories',
};

export const platformTypeOptions = [
  { value: 'email', label: 'Email' },
  { value: 'attachment', label: 'Attachment' },
  { value: 'ticket', label: 'Ticket (Zendesk)' },
  { value: 'direct', label: 'Direct' },
  { value: 'group', label: 'Group' },
  { value: 'channel', label: 'Channel' },
  { value: 'o365', label: 'O365' },
  { value: 'o365_ssp', label: 'O365 SSP' },
  { value: 'o365_teams', label: 'O365 Teams' },
  { value: 'slack', label: 'Slack' },
  { value: 'glia', label: 'Glia' },
  { value: 'unknown', label: 'Unknown' },
  { value: 'Unknown Recipient', label: 'Unknown Recipient' },
  { value: 'email_translation', label: 'Email Translation' },
  { value: 'direct_translation', label: 'Direct Translation' },
  { value: 'channel_translation', label: 'Channel Translation' },
  { value: 'attachment_translation', label: 'Attachment Translation' },
  { value: 'pdf', label: 'PDF (OneDrive)' },
  { value: 'test', label: 'Test' },
];

export const identifierNamePageMap = {
  llm_categorizer: LlmCategorizerName,
};

export const defaultIdentifiersOptionsConfig = {
  llm_chain: { feature: '', min_threshold: 0.0, prompt: '' },
};

export default MATCHER_TYPE;
